import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MenuPage from "./Pages/menu.jsx";
import DashboardPage from "./Pages/dashboard.jsx";
import Login from "./Pages/login.jsx";
import ProtectedRoute from "./Components/ProtectedRoute.jsx";
import { Toaster } from "sonner";
import { CartProvider } from "./Context/CartContext.jsx";
import LandingPage from "./Pages/landing.jsx";
import { NotFound } from "./Pages/404.jsx";
import React from "react";
function App() {
  return (
    <div className="App">
      <Toaster richColors />
      <Router>
        <Routes>
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />

          <Route
            path="/menu/*"
            element={
              <CartProvider>
                <MenuPage />
              </CartProvider>
            }
          />
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
